import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { getCurrentUser } from 'aws-amplify/auth';
 
// Wraps any route that requires a logged-in user. If no valid session
// exists, redirects to /login instead of rendering the protected page.
function ProtectedRoute({ children }) {
  const [checking, setChecking] = useState(true);
  const [authenticated, setAuthenticated] = useState(false);
 
  useEffect(() => {
    const checkAuth = async () => {
      try {
        await getCurrentUser();
        setAuthenticated(true);
      } catch {
        setAuthenticated(false);
      }
      setChecking(false);
    };
    checkAuth();
  }, []);
 
  if (checking) {
    // Brief blank screen while we verify the session — avoids a flash
    // of the protected page before redirecting.
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        backgroundColor: '#f0f4f8'
      }} />
    );
  }
 
  if (!authenticated) {
    return <Navigate to="/login" replace />;
  }
 
  return children;
}
 
export default ProtectedRoute;